import Notification from '../../components/layout/headquarters/Notification';
import '../../assets/css/pages/headquarters/notification.css';

const NotificationPage = () => {
    return <Notification />;
};

export default NotificationPage;
